export const MAP_PROXY = '/map-proxy';
